import React from 'react';
import { useState, useEffect } from 'react';
import { Checkmark } from 'react-checkmark';
import Confetti from 'react-confetti';
import { connect } from 'react-redux';
import { postPlaytime } from '../redux/actions/buddyBooks';
import "./styles.scss";

let tC = localStorage.getItem("time");
let rT = localStorage.getItem("reporting_time");
let rTLeft = rT && JSON.parse(rT);
let timeCompleted = tC && JSON.parse(tC);

let playtimeSec = (rTLeft && Number(rTLeft)) || 0;
let closeConfetti = true;
const Timer = ({ playComputer, playRecording, audioUrl, studentHistory, playtime, dispatch }) => {
    let initializeMinutes = Math.max(0, studentHistory?.readingTime - playtime);
    const [minutes, setMinutes] = useState(initializeMinutes);
    const [seconds, setSeconds] = useState(0);
    const [ptTime, setPtTime] = useState(playtimeSec);
    const [showConfetti, setShowConfetti] = useState(false);

    useEffect(() => {
        console.log("__bb timer ", studentHistory, playtime);
        if (studentHistory && (playtime || playtime === 0)) {
            const { readingTime } = studentHistory;
            console.log("playtime ", Math.max(0, readingTime - playtime));
            let min = Math.max(0, readingTime - playtime);
            setMinutes(min);
            setSeconds(0);
        }
    }, [playtime])

    useEffect(() => {
        let myInterval = setInterval(() => {
            if ((playComputer && audioUrl) || playRecording) {
                if (ptTime % 60 === 0 && ptTime !== 0) {
                    console.log("playtime reported ");
                    dispatch(postPlaytime());
                    setPtTime(ptTime + 1);
                } else {
                    setPtTime(ptTime + 1);
                    localStorage.setItem("reporting_time", JSON.stringify(ptTime));
                }
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                }
                if (seconds === 0) {
                    if (minutes !== 0) {
                        setMinutes(minutes - 1);
                        setSeconds(59);
                    }
                }
            }
            if (!isNaN(minutes) && minutes === 0 && !isNaN(seconds) && seconds === 0 && !showConfetti && closeConfetti) {
                if (playComputer) {
                    setShowConfetti(true);
                    closeConfetti = false;
                    setTimeout(() => {
                        setShowConfetti(false);
                    }, 10000);
                }
            }
        }, 1000);
        return () => {
            clearInterval(myInterval);
        };
    }, [playComputer, playRecording, audioUrl, minutes, seconds, ptTime]);

    return (
        <>
            {(minutes || (minutes === 0 && seconds)) ?
                <div className='timer_container'>
                    <div className='timer_tick'>
                        {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                    </div>
                </div> :
                <div className='timer_container'>
                    <Checkmark size="medium" />
                </div>}

            {showConfetti && <Confetti />}
        </>)
}

const mapState = ({ platform: { student: { studentHistory, playtime } } }) => {
    return {
        studentHistory,
        playtime
    }
};

export default connect(mapState)(Timer);